(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thalo-personalized"]) return;
  try {
    
document.addEventListener('change', (event) => {
const input = event.target;
if (!(input instanceof HTMLInputElement) || input.type !== 'file' || !input.closest('.thalo-photo')) return;
const file = input.files[0];
const valid = !file || (file.size <= 10000000 && ['image/jpeg','image/png','image/webp'].includes(file.type));
input.setCustomValidity(valid ? '' : input.form.querySelector('[id^="Help-"]').textContent);
input.reportValidity();
});

  } catch(e) { console.error(e); }
})();
})();
